module.exports = __webpack_public_path__ + "static/img/ikonaNotatka-ON.47cf2245.png";